import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { AddHallPassReasonRequest } from "./AddHallPassReasonRequest";
import { AddTimeScanManuallyRequest } from "./AddTimeScanManuallyRequest";
import { HallPassInsertRequest } from "./HallPassInsertRequest";
import { HallPassUpdateRequest } from "./HallPassUpdateRequest";
import { LoadDataFromBarcodeRequest } from "./LoadDataFromBarcodeRequest";
import { MenuSchoolInfoRequest } from "./MenuSchoolInfoRequest";
import { UpdateHallPassReasonRequest } from "./UpdateHallPassReasonRequest";
import { SavePreferenceRequest } from "./SavePreferenceRequest";

@Injectable()
export class ScanPointService {
	constructor(private httpclientService: HttpclientService) {}

	private subject = new Subject<any>();
	studentSelectedChanged(person) {
		this.subject.next(person);
	}

	onsStudentSelectChange(): Observable<any> {
		return this.subject.asObservable();
	}

	loadFacilityList(applicationItemID, UserID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/FacilityGetListByUserID?ApplicationItemID=" + applicationItemID + "&UserID=" + UserID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadFacilityLocationList(applicationItemID, facilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/FacilityLocationGetList?ApplicationItemID=" + applicationItemID + "&FacilityID=" + facilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadReceiptPrinterList(applicationItemID, facilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ReceiptPrinterGetList?ApplicationItemID=" + applicationItemID + "&FacilityID=" + facilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadHallpassReasonList(applicationItemID, facilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallpassReasonGetList?ApplicationItemID=" + applicationItemID + "&FacilityID=" + facilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadClassAttendanceExcuseSelectList(applicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ClassAttendanceExcuseSelectList?ApplicationItemID=" + applicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadHallpassReason(applicationItemID, ReasonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallpassReasonSelect?ApplicationItemID=" + applicationItemID + "&ReasonID=" + ReasonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSPPreferences(personID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/SPGetPreferences?PersonID=" + personID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SavePreferences(parms: SavePreferenceRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/SavePreferences";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddHallPassReason(parms: AddHallPassReasonRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/AddHallPassReason";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateHallPassReason(parms: UpdateHallPassReasonRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/UpdateHallPassReason";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DeleteHallPassReason(applicationItemID, HallpassReasonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DeleteHallPassReason?ApplicationItemID=" + applicationItemID + "&ReasonID=" + HallpassReasonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDataFromBarcode(parms: LoadDataFromBarcodeRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/LoadDataFromBarcode";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadDataFromPerson(applicationItemID, PersonID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/loadDataFromPerson?ApplicationItemID=" + applicationItemID + "&PersonID=" + PersonID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DynamicGroupGetList(applicationItemID, AudienceID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DynamicGroupsGetList?ApplicationItemID=" + applicationItemID + "&AudienceID=" + AudienceID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DynamicValuesGetList(applicationItemID, DynamicGroupSQL, SchoolID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DynamicValuesGetList?ApplicationItemID=" + applicationItemID + "&DynamicGroupSQL=" + DynamicGroupSQL + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TimeScanTypeGetList(ApplicationItemID, SchoolID, IsUserSelectable) {
		var postResult$ = new Subject();
		var url = "ScanPoint/TimeScanTypeGetList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID + "&IsUserSelectable=" + IsUserSelectable;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonInfoGet(ApplicationItemID, PersonID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/PersonInfoGet?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MenuSchoolInfoGetList(parms: MenuSchoolInfoRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/MenuSchoolInfoGetList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MenuDistrictInfoGetList(ApplicationItemID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/MenuDistrictInfoGetList?ApplicationItemID=" + ApplicationItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MenuFacilityInfoGetList(ApplicationItemID, Active) {
		var postResult$ = new Subject();
		var url = "ScanPoint/MenuFacilityInfoGetList?ApplicationItemID=" + ApplicationItemID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MenuContainerInfoGetList(ApplicationItemID, Active) {
		var postResult$ = new Subject();
		var url = "ScanPoint/MenuContainerInfoGetList?ApplicationItemID=" + ApplicationItemID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DynamicGroupPersonInfoGetList(ApplicationItemID, SchoolID, DynamicGroupID, DynamicGroupValue, FilterText, Active, PersonTypeID, FacilityID) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/DynamicGroupPersonInfoGetList?ApplicationItemID=" +
			ApplicationItemID +
			"&SchoolID=" +
			SchoolID +
			"&DynamicGroupID=" +
			DynamicGroupID +
			"&DynamicGroupValue=" +
			DynamicGroupValue +
			"&FilterText=" +
			FilterText +
			"&Active=" +
			Active +
			"&PersonTypeID=" +
			PersonTypeID +
			"&FacilityID=" +
			FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RecentAttendanceGetList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/RecentAttendanceGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RecentIDHistoryGetList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/RecentIDHistoryGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DayOptionSelectList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DayOptionSelectList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	DayOptionByFacilityIDSelectList(ApplicationItemID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/DayOptionByFacilityIDSelectList?ApplicationItemID=" + ApplicationItemID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScheduleInfoGetList(ApplicationItemID, PersonID, Option) {
		var postResult$ = new Subject();
		var url = "ScanPoint/ScheduleInfoGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID + "&Option=" + Option;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassInfoGetList(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassInfoGetList?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassInsert(parms: HallPassInsertRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassUpdate(parms: HallPassUpdateRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	HallPassReprint(HallpassID, IDPrinterID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/HallPassReprint?HallpassID=" + HallpassID + "&IDPrinterID=" + IDPrinterID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadAlertsForPerson(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/LoadAlertsForPerson?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	IDStatusSelectList(ApplicationItemID, IsManualMode) {
		var postResult$ = new Subject();
		var url = "ScanPoint/IDStatusSelectList?ApplicationItemID=" + ApplicationItemID + "&IsManualMode=" + IsManualMode;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanManualInsert(
		BarcodeStatusID,
		Admin_PersonID,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReplaceFee,
		TempIDFee,
		PersonID,
		ScanDT
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/ScanManualInsert?BarcodeStatusID=" +
			BarcodeStatusID +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReplaceFee=" +
			ReplaceFee +
			"&TempIDFee=" +
			TempIDFee +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	StaffInfoGet(ApplicationItemID, PersonID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/StaffInfoGet?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanTimeInsert(BarcodeStatusID, Admin_PersonID, PersonID, ScanDT, TimeScanTypeID) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/ScanTimeInsert?BarcodeStatusID=" +
			BarcodeStatusID +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&TimeScanTypeID=" +
			TimeScanTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetSound(ApplicationItemID, SoundLibraryID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/LoadSoundFile?ApplicationItemID=" + ApplicationItemID + "&SoundLibraryID=" + SoundLibraryID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TardyExcuseGetList(ApplicationItemID, SchoolID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/TardyExcuseGetList?ApplicationItemID=" + ApplicationItemID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	TardyExcuseGetListFromFacility(ApplicationItemID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/TardyExcuseGetListFromFacility?ApplicationItemID=" + ApplicationItemID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GetFeePreferencesFromFacilityID(ApplicationItemID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/GetFeePreferencesFromFacilityID?ApplicationItemID=" + ApplicationItemID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ManualEntryScan(
		BarcodeStatusID,
		Admin_PersonID,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReplaceFee,
		TempIDFee,
		PersonID,
		ScanDT
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/ManualEntryScan?BarcodeStatusID=" +
			BarcodeStatusID +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReplaceFee=" +
			ReplaceFee +
			"&TempIDFee=" +
			TempIDFee +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonGetFine(ApplicationItemID, PersonID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/PersonGetFine?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EventGetListByFacility(ApplicationItemID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/EventGetListByFacility?ApplicationItemID=" + ApplicationItemID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EventScanTypeGetList(ApplicationItemID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/EventScanTypeGetList?ApplicationItemID=" + ApplicationItemID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	MealGetListByFacility(ApplicationItemID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/MealGetListByFacility?ApplicationItemID=" + ApplicationItemID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddTimeScan(BarcodeStatusID, PersonID, ScanDT, Admin_PersonID, TimeScanTypeID) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddTimeScan?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&TimeScanTypeID=" +
			TimeScanTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddTimeScanManually(parms: AddTimeScanManuallyRequest) {
		var postResult$ = new Subject();
		var url = "ScanPoint/AddTimeScanManually";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddEntryScan(
		BarcodeStatusID,
		PersonID,
		ScanDT,
		Admin_PersonID,
		FacilityID,
		EntryDate,
		EntryTime,
		AttendanceStatusID,
		ExcuseID,
		EntryTypeID,
		ReleaseScheduleID,
		Suspended,
		c_date,
		IsTentative
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddEntryScan?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&FacilityID=" +
			FacilityID +
			"&EntryDate=" +
			EntryDate +
			"&EntryTime=" +
			EntryTime +
			"&AttendanceStatusID=" +
			AttendanceStatusID +
			"&ExcuseID=" +
			ExcuseID +
			"&EntryTypeID=" +
			EntryTypeID +
			"&ReleaseScheduleID=" +
			ReleaseScheduleID +
			"&Suspended=" +
			Suspended +
			"&c_date=" +
			c_date +
			"&IsTentative=" +
			IsTentative;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddEntryScanManually(
		BarcodeStatusID,
		PersonID,
		ScanDT,
		Admin_PersonID,
		FacilityID,
		EntryDate,
		EntryTime,
		AttendanceStatusID,
		ExcuseID,
		EntryTypeID,
		ReleaseScheduleID,
		Suspended,
		c_date,
		IsTentative,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReprintFee,
		TempIDFee
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddEntryScanManually?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&FacilityID=" +
			FacilityID +
			"&EntryDate=" +
			EntryDate +
			"&EntryTime=" +
			EntryTime +
			"&AttendanceStatusID=" +
			AttendanceStatusID +
			"&ExcuseID=" +
			ExcuseID +
			"&EntryTypeID=" +
			EntryTypeID +
			"&ReleaseScheduleID=" +
			ReleaseScheduleID +
			"&Suspended=" +
			Suspended +
			"&c_date=" +
			c_date +
			"&IsTentative=" +
			IsTentative +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReprintFee=" +
			ReprintFee +
			"&TempIDFee=" +
			TempIDFee;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddExitScan(BarcodeStatusID, PersonID, ScanDT, Admin_PersonID) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddExitScan?BarcodeStatusID=" + BarcodeStatusID + "&PersonID=" + PersonID + "&ScanDT=" + ScanDT + "&Admin_PersonID=" + Admin_PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddExitScanManually(
		BarcodeStatusID,
		PersonID,
		ScanDT,
		Admin_PersonID,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReprintFee,
		TempIDFee
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddExitScanManually?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReprintFee=" +
			ReprintFee +
			"&TempIDFee=" +
			TempIDFee;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddMealScan(BarcodeStatusID, PersonID, ScanDT, Admin_PersonID, MealID, MealSubsidyTypeID, Active) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddMealScan?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&MealID=" +
			MealID +
			"&MealSubsidyTypeID=" +
			MealSubsidyTypeID +
			"&Active=" +
			Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddMealScanManually(
		BarcodeStatusID,
		PersonID,
		ScanDT,
		Admin_PersonID,
		MealID,
		MealSubsidyTypeID,
		Active,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReprintFee,
		TempIDFee
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddMealScanManually?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&MealID=" +
			MealID +
			"&MealSubsidyTypeID=" +
			MealSubsidyTypeID +
			"&Active=" +
			Active +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReprintFee=" +
			ReprintFee +
			"&TempIDFee=" +
			TempIDFee;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddAccessScan(BarcodeStatusID, PersonID, ScanDT, Admin_PersonID, ScanAccessModeID, CourseTypeID, SectionInfo, RoomNo) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddAccessScan?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&ScanAccessModeID=" +
			ScanAccessModeID +
			"&CourseTypeID=" +
			CourseTypeID +
			"&SectionInfo=" +
			SectionInfo +
			"&RoomNo=" +
			RoomNo;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddAccessScanManually(
		BarcodeStatusID,
		PersonID,
		ScanDT,
		Admin_PersonID,
		ScanAccessModeID,
		CourseTypeID,
		SectionInfo,
		RoomNo,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReprintFee,
		TempIDFee
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddAccessScanManually?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&ScanAccessModeID=" +
			ScanAccessModeID +
			"&CourseTypeID=" +
			CourseTypeID +
			"&SectionInfo=" +
			SectionInfo +
			"&RoomNo=" +
			RoomNo +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReprintFee=" +
			ReprintFee +
			"&TempIDFee=" +
			TempIDFee;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddEventScan(BarcodeStatusID, PersonID, ScanDT, Admin_PersonID, EventID, EventScanTypeID) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddEventScan?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&EventID=" +
			EventID +
			"&EventScanTypeID=" +
			EventScanTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	AddEventScanManually(
		BarcodeStatusID,
		PersonID,
		ScanDT,
		Admin_PersonID,
		EventID,
		EventScanTypeID,
		ManualComment,
		ReprintCardInd,
		PrintedTempInd,
		ChargeReprintFeeInd,
		ChargeTempFeeInd,
		PaidAmount,
		ReprintFee,
		TempIDFee
	) {
		var postResult$ = new Subject();
		var url =
			"ScanPoint/AddEventScanManually?BarcodeStatusID=" +
			BarcodeStatusID +
			"&PersonID=" +
			PersonID +
			"&ScanDT=" +
			ScanDT +
			"&Admin_PersonID=" +
			Admin_PersonID +
			"&EventID=" +
			EventID +
			"&EventScanTypeID=" +
			EventScanTypeID +
			"&ManualComment=" +
			ManualComment +
			"&ReprintCardInd=" +
			ReprintCardInd +
			"&PrintedTempInd=" +
			PrintedTempInd +
			"&ChargeReprintFeeInd=" +
			ChargeReprintFeeInd +
			"&ChargeTempFeeInd=" +
			ChargeTempFeeInd +
			"&PaidAmount=" +
			PaidAmount +
			"&ReprintFee=" +
			ReprintFee +
			"&TempIDFee=" +
			TempIDFee;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BelongsInFacility(ApplicationItemID, PersonID, FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/BelongsInFacility?ApplicationItemID=" + ApplicationItemID + "&PersonID=" + PersonID + "&FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadFacilityAndLocationNames(FacilityID, FacilityLocationID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/LoadFacilityAndLocationNames?FacilityID=" + FacilityID + "&FacilityLocationID=" + FacilityLocationID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	loadSoundLibraryList(FacilityID) {
		var postResult$ = new Subject();
		var url = "ScanPoint/SoundLibrarySelectList?FacilityID=" + FacilityID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
